export function checkLogin() {
    return (!!document.cookie.match('.WebAquarell')) && document.cookie.match('.WebAquarell').input !== ".WebAquarell=";
};

export function exitAdmin() {
    document.cookie = '.WebAquarell=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    window.location.href = '/';
};
